import { useState, useCallback } from 'react';
import { encryptData, decryptData } from '../utils/methods';

export function usePersistentFilters<T>(storageKey: string, defaultFilters: T) {
  // Load initial state (From Storage or Defaults)
  const [initialFilters] = useState<T>(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) {
        const decrypted = decryptData(saved);
        if (decrypted) return decrypted;
      }
    } catch (error) {
      console.error("Error loading filters from storage:", error);
    }
    return defaultFilters;
  });

  const saveFilters = useCallback((filters: T) => {
    try {
      const encrypted = encryptData(filters);
      localStorage.setItem(storageKey, encrypted);
    } catch (error) {
      console.error("Error saving filters to storage:", error);
    }
  }, [storageKey]);

  const resetFilters = useCallback(() => {
    localStorage.removeItem(storageKey);
  }, [storageKey]);

  return { initialFilters, saveFilters, resetFilters };
}
